<script lang="ts">
  import FontSizeDecorator from '$components/SanityComponents/PortableText/Decorators/FontSizeDecorator.svelte';

  interface Props {
    loading: boolean;
  }

  let { loading }: Props = $props();

  let progress = $state<number | null>(null);
  let messageIndex = $state(0);
  let progressInterval: number;
  let messageInterval: number;

  const loadingMessages = [
    'Processing your question...',
    'Searching through documentation...',
    'Analyzing relevant articles...',
    'Generating a helpful response...',
    'Almost there...'
  ];

  $effect(() => {
    if (loading) {
      progress = 0;
      messageIndex = 0;

      progressInterval = window.setInterval(() => {
        // Move faster at first, then slow down
        if (progress !== null && progress < 90) {
          const increment = progress < 20 ? 5 : progress < 60 ? 3 : 1;
          progress = Math.min(90, progress + increment);
        }
      }, 300);

      messageInterval = window.setInterval(() => {
        messageIndex = (messageIndex + 1) % loadingMessages.length;
      }, 1000);
    } else {
      clearInterval(progressInterval);
      clearInterval(messageInterval);

      progress = null;
    }

    return () => {
      clearInterval(progressInterval);
      clearInterval(messageInterval);
    };
  });
</script>

{#if loading}
  <div class="loading-message">
    <div class="loading-content">
      <div class="progress-container">
        <div class="progress-bar">
          <div class="progress-fill" style="--progress: {progress}%"></div>
        </div>
      </div>
      <p class="status-message">
        <FontSizeDecorator>{loadingMessages[messageIndex]}</FontSizeDecorator>
      </p>
    </div>
  </div>
{/if}

<style lang="scss">
  @import 'src/scss/variables.scss';

  .loading-message {
    align-self: flex-start;
    padding: 16px;
    background: $background-depth-1-color;
    border-radius: 12px;
    min-width: 300px;
  }

  .loading-content {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .progress-container {
    width: 100%;
    height: 4px;
    background: $background-depth-2-color;
    border-radius: 2px;
    overflow: hidden;
  }

  .progress-bar {
    position: relative;
    width: 100%;
    height: 100%;
  }

  .progress-fill {
    position: absolute;
    top: 0;
    left: 0;
    width: var(--progress);
    height: 100%;
    background-color: $text-default-color;
    transition: width 0.3s ease;
    animation: pulse 2s infinite;
  }

  .status-message {
    color: $text-helper-color;
    text-align: center;
    margin: 0;
    animation: fadeIn 0.3s ease;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(5px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes pulse {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.4;
    }
    100% {
      opacity: 1;
    }
  }
</style>
